var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 9.4829C0 8.31448 1.02514 7.36816 2.29257 7.36816H13.7074C14.3157 7.36928 14.8986 7.59254 15.3284 7.98898C15.7582 8.38542 15.9997 8.92267 16 9.4829V17.885C16 19.0534 14.9749 19.9997 13.7074 19.9997H2.29257C1.68423 19.9989 1.10111 19.7757 0.67127 19.3792C0.241428 18.9827 -6.78267e-07 18.4453 0 17.885V9.4829ZM8 15.7892C8.60621 15.7892 9.18759 15.5674 9.61624 15.1726C10.0449 14.7778 10.2857 14.2423 10.2857 13.684C10.2857 13.1256 10.0449 12.5901 9.61624 12.1953C9.18759 11.8005 8.60621 11.5787 8 11.5787C7.39379 11.5787 6.81241 11.8005 6.38376 12.1953C5.9551 12.5901 5.71429 13.1256 5.71429 13.684C5.71429 14.2423 5.9551 14.7778 6.38376 15.1726C6.81241 15.5674 7.39379 15.7892 8 15.7892Z",
    fill: "#7D7D82"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.42857 4.21263C3.42918 3.09591 3.91093 2.02505 4.76804 1.23521C5.62515 0.44537 6.78756 0.00111547 8 0C8.60052 -6.91371e-08 9.19516 0.108978 9.74994 0.320709C10.3047 0.532439 10.8088 0.842772 11.2333 1.23398C11.6578 1.62519 11.9945 2.0896 12.2241 2.60069C12.4537 3.11177 12.5717 3.65952 12.5714 4.21263V10.2002H10.2857V4.21263C10.2859 3.93603 10.2269 3.6621 10.1121 3.4065C9.99729 3.1509 9.82897 2.91862 9.61672 2.72293C9.40447 2.52725 9.15245 2.37198 8.87506 2.266C8.59766 2.16002 8.30031 2.1054 8 2.10526C6.74057 2.10526 5.71429 3.05053 5.71429 4.21263V9.47368H3.42857V4.21263Z",
    fill: "#7D7D82"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/Lock.bbe9469cb1aaf6e69c909fd68e4d451b.svg";
export { ForwardRef as ReactComponent };